import React, { useState } from "react";
import { Link, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import isEmail from "validator/lib/isEmail";
import { markdown } from "utils/others";
import useOnBoardingData from "hooks/useOnBoardingData";
import { getSiteName } from "actions/config";

const SignInEmail = (params) => {
    const { t } = useTranslation();
    const [passVisible, setPassVisible] = useState(false);
    const { email: emailFromParams, type } = useParams();

    const { register, handleSubmit, watch, errors, triggerValidation } = useForm();

    const { hasPWARegister, obData } = useOnBoardingData();

    const togglePassVisibility = () => setPassVisible((v) => !v);

    const onSubmit = handleSubmit((data) => {
        const finalEmail = (hasPWARegister && obData?.email) || emailFromParams || data.email || "";
        params.onSubmit({ ...data, email: finalEmail });
    });

    const showEmailFromOnBoarding = hasPWARegister && obData;

    return (
        <form onSubmit={onSubmit}>
            <div className="my-3">
                {showEmailFromOnBoarding ? (
                    <>
                        <p className="text-black font-bold">
                            {t("do-you-want-to-access-our-app", { app: getSiteName() })}
                        </p>
                        <div className="text-black">{t("enter-your-account-password")}</div>
                        <div className="text-black font-bold mb-4">{obData?.email}</div>
                        <input type="hidden" name="email" ref={register()} value={obData?.email || ""} readOnly />
                    </>
                ) : (
                    <>
                        {emailFromParams ? (
                            <>
                                <h1 className="font-bold text-lg mb-4">{t("login title")}</h1>
                                {type === "code" ? (
                                    <>
                                        {markdown(t("password sent to email", { email: emailFromParams }))}
                                        <br />
                                        <br />
                                        {t("enter account password")}
                                    </>
                                ) : (
                                    <>
                                        <p className="text-black font-bold">
                                            {t("do-you-want-to-access-our-app", { app: getSiteName() })}
                                        </p>
                                        {t("enter account password")}
                                        <br />
                                        <strong>{emailFromParams}</strong>
                                    </>
                                )}

                                <input type="hidden" name="email" ref={register()} value={emailFromParams} readOnly />
                            </>
                        ) : (
                            <>
                                <div className={"float-left text-sm pl-1 pb-1 " + (!watch("email") && "invisible")}>
                                    {t("email")}
                                </div>
                                <input
                                    ref={register({
                                        required: t("required input"),
                                        validate: (value) => isEmail(value) || t("invalid email"),
                                    })}
                                    type="email"
                                    name="email"
                                    id="input-email"
                                    placeholder={t("email")}
                                    onChange={() => triggerValidation("email")}
                                    className={errors.email ? "error" : ""}
                                />
                                {errors.email && (
                                    <div className="text-error float-right text-sm">{errors.email.message}</div>
                                )}
                            </>
                        )}
                    </>
                )}
            </div>

            <div className="mt-3 mb-5">
                <div className={"float-left text-sm pl-1 pb-1 " + (!watch("password") && "invisible")}>
                    {t("password")}
                </div>
                <div className="relative">
                    <input
                        ref={register({ required: true })}
                        type={passVisible ? "text" : "password"}
                        name={type === "code" ? type : "password"}
                        id="input-pass"
                        placeholder={t("password")}
                        onChange={() => triggerValidation("password")}
                        className={errors.password ? "error" : ""}
                    />
                    <i
                        className={
                            "absolute right-0 m-3 text-neutral-contrast-50 text-xl cursor-pointer icon icon-eye-" +
                            (passVisible ? "on" : "off")
                        }
                        id="toggle-pass-visibility"
                        onClick={togglePassVisibility}
                    />
                </div>
            </div>

            <Link
                to={emailFromParams ? "../forgot" : "forgot"}
                id="action-forgotpass"
                className="text-accent block align-baseline"
            >
                {t("forgot password?")}
            </Link>

            <button id="action-signin" type="submit" className="btn btn-accent block mx-auto mt-5 mb-2 w-full text-lg">
                {t("signin")}
            </button>
        </form>
    );
};

export default SignInEmail;
